
import React, { useEffect, useRef } from 'react';

interface LogConsoleProps {
  logs: string[];
}

export const LogConsole: React.FC<LogConsoleProps> = ({ logs }) => {
  const endRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to top (newest) is default because of flex-col-reverse or inserting at start
  // In the App.tsx implementation: setLogs(prev => [new, ...prev]);
  // So the top element is the newest. No auto-scroll to bottom needed.

  return (
    <div className="pt-2 mt-auto border-t border-gray-200">
        <label className="text-xs font-bold text-gray-500 mb-1 block mt-2">系统日志 / Debug Log</label>
        <div className="bg-black text-green-400 font-mono text-xs p-2 rounded h-32 overflow-y-auto shadow-inner border border-gray-600 leading-tight custom-scrollbar">
            {logs.length === 0 && <span className="opacity-50">暂无日志...</span>}
            {logs.map((log, i) => (
                <div key={i} className="mb-1 border-b border-gray-800 pb-0.5 break-all">{log}</div>
            ))}
        </div>
    </div>
  );
};
